import React, { Component } from 'react';
import Modal from 'react-awesome-modal';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { toggleBannerPreviewModal } from '../actions/dashboard-actions';

import '../styles/banner-preview-modal.css';

class BannerPreviewModal extends Component {
  closeModal() {
    const { toggleBannerPreviewModal } = this.props;

    toggleBannerPreviewModal(false, null);
  }

  render() {
    const { showBannerPreviewModal, bannerHtml } = this.props;

    return (
      <Modal visible={showBannerPreviewModal} effect="fadeInUp" onClickAway={() => this.closeModal()} className="banner-preview-modal">
        <span className="glyphicon glyphicon-remove-sign banner-preview-modal__close-btn" onClick={() => this.closeModal()} />
        <div dangerouslySetInnerHTML={{ __html: bannerHtml }} />
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  showBannerPreviewModal: state.dashboardReducer.showBannerPreviewModal,
  bannerHtml: state.dashboardReducer.bannerHtml,
});

const mapDispatchToProps = dispatch => ({
  toggleBannerPreviewModal: (show, bannerHtml) => {
    dispatch(toggleBannerPreviewModal(show, bannerHtml));
  },
});

BannerPreviewModal.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(BannerPreviewModal);



// WEBPACK FOOTER //
// ./src/app/main/dashboard/components/banner-preview-modal.js